import { BaseService, Service } from "/@/cool";

@Service("settleVersionGroup")
class SettleVersionGroupService extends BaseService {
	list(data?: any) {
		return this.request({
			url: "/list",
			method: "POST",
			data
		});
	}

	add(data: any) {
		return this.request({
			url: "/add",
			method: "POST",
			data
		});
	}

	update(data: any) {
		return this.request({
			url: "/update",
			method: "POST",
			data
		});
	}

	delete(data: { ids: number[] }) {
		return this.request({
			url: "/delete",
			method: "POST",
			data
		});
	}

	info(params: { id: number }) {
		return this.request({
			url: "/info",
			method: "GET",
			params
		});
	}

	order(items: Array<{ id: number; parent_id: number; sort: number }>, dealerId?: number) {
		return this.request({
			url: "/order",
			method: "POST",
			data: items,
			params: dealerId ? { dealer_id: dealerId } : {}
		});
	}
}

export default SettleVersionGroupService;
